import WidgetHub from "@/components/WidgetHub";
import { ClipboardList, ShoppingCart, PackageCheck, Inbox, BookOpen, Boxes, FileText } from "lucide-react";

export default function PurchaseHub() {
  const widgets = [
    { label: "Requisitions", description: "Raise & track purchase requisitions", to: "/org/requisitions", icon: ClipboardList },
    { label: "Purchase orders", description: "Convert PRs to POs, send to vendors", to: "/org/purchase-orders", icon: ShoppingCart },
    { label: "GRN", description: "Goods receipt notes & inbound QC", to: "/org/grn", icon: PackageCheck },
    { label: "Vendor invoices", description: "AP invoices from vendors", to: "/org/finance/payables", icon: FileText, accent: "bg-emerald-500/10" },
    { label: "Vendors", description: "Vendor master · contacts, GSTIN", to: "/org/vendors", icon: Inbox, accent: "bg-blue-500/10" },
    { label: "Items master", description: "Items with vendor & price", to: "/org/items", icon: Boxes },
    { label: "Approvals inbox", description: "Pending purchase approvals", to: "/org/approvals", icon: Inbox },
    { label: "Approval rules", description: "Threshold & escalation rules", to: "/org/approval-rules", icon: BookOpen },
  ];
  return <WidgetHub title="Purchase" subtitle="Everything procurement — from requisitions to GRN to vendor invoices to vendor master." widgets={widgets} testid="purchase-hub" />;
}
